const formatter = new Intl.NumberFormat('pt-br', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 1,
});
const formatterMoneyAsInteger = new Intl.NumberFormat('pt-br', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
});
const numberFormatter = new Intl.NumberFormat('pt-br');

export const labelFormatterPercentile = (value: number) =>
  `${(Math.round(value * 100) / 100).toFixed(2)}%`;
export const labelFormatterPercentileInteger = (value: number) =>
  `${Math.round(Math.round(value * 100) / 100)}%`;
export const labelFormatterMoneyAsFloat = (value: number) =>
  formatter.format(value);
export const labelFormatterMoneyAsInteger = (value: number) => {
  return formatterMoneyAsInteger.format(value);
};
export const labelFormatterBillions = (value: number) =>
  `${formatter.format(value)} bi`;
export const labelFormatterNumber = (value: number) =>
  numberFormatter.format(value);
export const labelFormatterMillions = (value: number) =>
  `${formatter.format(value)} mi`;

export const unmaskPercentile = (percentile: string): number => {
  const unmasked = percentile.replace('%', '').replaceAll(',', '.');
  return Number(unmasked);
};

export const unmaskAbsoluteValue = (value: string): number => {
  const unmasked = value.replaceAll('.', '').replaceAll(',', '.');
  return Number(unmasked);
};

export const convertToPagePixel = (size: number) => {
  return size * 0.4355783309;
};
export const labelFormatterPercentileSymbol = (value: number) => `${value} %`;
